import { render, staticRenderFns } from "./WorldMapLB.vue?vue&type=template&id=42967a6e&scoped=true"
import script from "./WorldMapLB.vue?vue&type=script&lang=js"
export * from "./WorldMapLB.vue?vue&type=script&lang=js"
import style0 from "./WorldMapLB.vue?vue&type=style&index=0&id=42967a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42967a6e",
  null
  
)

export default component.exports